// extracted by mini-css-extract-plugin
export default {"heading":"ModuleHeader_heading__cnSXg","paragraph":"ModuleHeader_paragraph__VFKn0","ctaButton":"ModuleHeader_ctaButton__cuWKO","line":"ModuleHeader_line__dr3RL"};